// src/pages/CampaignDashboard/modals/AutopilotModal.js

import React from 'react';

const AutopilotModal = ({ isOpen, onClose, onStart, promptData, selectedPrompt, onPromptSelect }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white w-[1200px] h-[800px] p-8 rounded-lg shadow-lg relative overflow-auto">
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-xl font-bold">Autopilot</h2>
                    <button onClick={onClose} className="text-gray-500">✖</button>
                </div>
                
                <div className="mb-3 p-4 bg-gray-100 rounded-lg">
                    {/* ... Instructions ... */}
                </div>

                <div className="bg-white p-6 rounded-lg shadow-lg mb-4 h-[500px] overflow-auto">
                    {promptData.length > 0 ? (
                        <div className="grid grid-cols-2 gap-4">
                            {promptData.map((prompt, index) => (
                                <div
                                    key={prompt.prompt_id}
                                    className={`w-full border-4 p-4 rounded-lg cursor-pointer ${selectedPrompt?.prompt_id === prompt.prompt_id ? 'border-blue-500' : 'border-gray-300'}`}
                                    onClick={() => onPromptSelect(prompt)}
                                >
                                    {/* ... prompt content ... */}
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p>Loading prompts...</p>
                    )}
                </div>

                <div className="grid grid-cols-2 gap-4 items-center mt-4">
                    <div className='flex justify-center'>
                        <button onClick={onStart} className="py-2 w-[300px] bg-blue-600 text-white font-bold rounded-full">
                            Start Autopilot
                        </button>
                    </div>
                    <div className='flex justify-center'>
                        <button onClick={onClose} className="py-2 w-[300px] bg-red-600 text-white font-bold rounded-full">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AutopilotModal;